import { render } from "./SeriesData.vue?vue&type=template&id=10b1edfc&bindings={}"
import script from "./SeriesData.vue?vue&type=script&lang=js"
export * from "./SeriesData.vue?vue&type=script&lang=js"
script.render = render

export default script